import { render, staticRenderFns } from "./VersionIcon.vue?vue&type=template&id=31d3fb1c&scoped=true&"
import script from "./VersionIcon.vue?vue&type=script&lang=js&"
export * from "./VersionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d3fb1c",
  null
  
)

export default component.exports